import { takeEvery, select, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { NEWS_EVENT_UPDATE_REQUEST, NEWS_EVENT_CREATE_REQUEST } from "./consts";
import { setNewsEventSubscription } from "./actions";
import { newsEventApi, validationErrorsOf } from "./api";
import { themeValueOf } from "./DefaultValue/eventCatalog";
import { ToastInfo } from "../MainPage/components/toast";

const TOAST_OPTIONS = { position: toast.POSITION.TOP_RIGHT };

// Themes are held in state as lower cased keys so they can be compared against
// what the API returns; they go back out in the calendar's own casing, and
// always in English regardless of `language`.
const toRequestBody = ({ language, themes, triggers }) => ({
  language,
  themes: (themes || []).map(themeValueOf),
  triggers: triggers || [],
});

// The API rejects an empty themes or triggers list with a 400 carrying
// validationErrors. Turn those into something a reader understands.
const describeFailure = (error, translation) => {
  const errors = validationErrorsOf(error);
  if (!errors.length) return translation.newsEvent.toast.requestFailed;

  const messages = errors.map(
    (item) => translation.newsEvent.validation[item.field] || item.message
  );
  return messages.join(" ");
};

export function* newsEventPageSaga() {
  yield takeEvery(NEWS_EVENT_UPDATE_REQUEST, updateNewsEventSubscription);
  yield takeEvery(NEWS_EVENT_CREATE_REQUEST, createNewsEventSubscription);
}

function* updateNewsEventSubscription({ payload }) {
  const { translation, fonts } = payload;
  const subscription = yield select((state) => state.newsEventPage.subscription);

  try {
    const response = yield newsEventApi.update(
      subscription.id,
      toRequestBody(subscription)
    );
    yield put(setNewsEventSubscription(response.data));
    toast(
      <ToastInfo content={translation.toast.updates} fonts={fonts} />,
      TOAST_OPTIONS
    );
  } catch (e) {
    toast(
      <ToastInfo content={describeFailure(e, translation)} fonts={fonts} />,
      TOAST_OPTIONS
    );
  }
}

function* createNewsEventSubscription({ payload }) {
  const { email, themes, triggers, language, translation, fonts, onSuccess } =
    payload;
  const listingId = yield select(
    (state) => state.newsEventPage.subscription.listingId
  );

  try {
    // Re-subscribing an existing address upserts and returns 201 with the
    // same id, so there is no conflict case to handle here.
    yield newsEventApi.create(listingId, {
      ...toRequestBody({ language, themes, triggers }),
      email,
    });
    if (onSuccess) onSuccess();
    toast(
      <ToastInfo
        title={translation.toast.youWereSuccessfully}
        content={`${translation.toast.confirmationMessage} ${translation.toast.pleaseAcceptTheRequest}`}
        fonts={fonts}
      />,
      TOAST_OPTIONS
    );
  } catch (e) {
    toast(
      <ToastInfo content={describeFailure(e, translation)} fonts={fonts} />,
      TOAST_OPTIONS
    );
  }
}
